import { DialogContent, DialogTitle } from "@mui/material";

import { PrimaryButton } from "../buttons/Buttons";
import type { AcceptanceDialogProps } from "./types";

export const createAcceptanceModalDialogProps = ({
  header,
  message,
  confirmLabel,
  onConfirm,
}: Pick<AcceptanceDialogProps, "header" | "message" | "confirmLabel" | "onConfirm">) => ({
  children: (
    <>
      <DialogTitle>{header}</DialogTitle>
      <DialogContent>{message}</DialogContent>
    </>
  ),
  buttons: (
    <PrimaryButton onClick={() => onConfirm(true)} data-test="close-button">
      {confirmLabel}
    </PrimaryButton>
  ),
});
